import "./style.css";
import { BsInstagram } from "react-icons/bs";
import { BsLinkedin } from "react-icons/bs";

const Header = (props) => {
  return (
    <>
      <header className={props.className}>
        <div className="header">
          <div className="logo"></div>
          <div className="getin">
            <button onClick={props.showModalNow} className="touch">
              Get In Touch
            </button>
          </div>
          <p className="primary-header">
            <span className="greeting">Hey, my name is</span>
            <br></br> <span className="name">Abhijith Pillai.</span>
            <br></br>
            <span className="web">I am an enthusiastic Web Developer.</span>
          </p>
          <a
            target="_blank"
            href="https://drive.google.com/file/d/1bvLAQGrvwLOJbFzOSlCQAeJRPxOJS748/view?usp=sharing"
          >
            <button className="btn btn-header">Download CV</button>
          </a>
        </div>
      </header>
    </>
  );
};
export default Header;
